module.exports = __webpack_public_path__ + "static/media/bg09.9d39e549.jpg";